module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4r8r7n-892f8523c337054e237cf24c48f1f296.svg";